import './loading.css';

export function LoadingIndicator({ label = 'Đang cập nhật…' }: { label?: string }) {
  return (
    <span className="loading-indicator" role="status">
      <span className="loading-spinner" aria-hidden="true" />
      {label}
    </span>
  );
}

export function LoadingSkeleton({
  variant = 'table',
  label = 'Đang tải dữ liệu…',
}: {
  variant?: 'page' | 'dashboard' | 'charts' | 'table' | 'detail' | 'document' | 'sidebar';
  label?: string;
}) {
  if (variant === 'document')
    return (
      <section className="loading-document" aria-busy="true" aria-label={label}>
        <header aria-hidden="true">
          <div>
            <span className="loading-block" />
            <span className="loading-block" />
            <span className="loading-block" />
          </div>
          <span className="loading-block" />
        </header>
        <LoadingIndicator label={label} />
        <div className="loading-document-viewport" aria-hidden="true">
          <div className="loading-document-sheet">
            {[85, 95, 70, 90, 65, 95, 80, 90].map((width, i) => (
              <span className="loading-block" key={i} style={{ width: `${width}%` }} />
            ))}
          </div>
        </div>
      </section>
    );
  if (variant === 'sidebar')
    return (
      <section
        className="loading-skeleton loading-skeleton-sidebar"
        aria-busy="true"
        aria-label={label}
      >
        <LoadingIndicator label={label} />
        <div className="loading-sidebar-rows" aria-hidden="true">
          {Array.from({ length: 4 }, (_, i) => (
            <div className="loading-sidebar-row" key={i}>
              <span className="loading-block" />
              <span className="loading-block" />
              <span className="loading-block" />
            </div>
          ))}
        </div>
      </section>
    );
  const cards = variant === 'page' || variant === 'dashboard' || variant === 'charts';
  return (
    <section
      className={`loading-skeleton loading-skeleton-${variant}`}
      aria-busy="true"
      aria-label={label}
    >
      <LoadingIndicator label={label} />
      <div aria-hidden="true">
        {variant !== 'charts' && variant !== 'dashboard' && (
          <div className="loading-heading">
            <span className="loading-block" />
            <span className="loading-block" />
          </div>
        )}
        {(variant === 'page' || variant === 'dashboard') && (
          <div className="loading-kpis">
            {Array.from({ length: 4 }, (_, i) => (
              <div className="loading-card" key={i}>
                <span className="loading-block" />
                <span className="loading-block loading-value" />
              </div>
            ))}
          </div>
        )}
        {variant === 'dashboard' && (
          <div className="loading-dashboard-toolbar">
            <span className="loading-block" />
          </div>
        )}
        {cards ? (
          <div className="loading-chart-grid">
            {Array.from({ length: 4 }, (_, i) => (
              <div className="loading-card loading-chart" key={i}>
                <span className="loading-block" />
                {[70, 95, 50].map((width) => (
                  <span
                    key={width}
                    className="loading-block loading-bar"
                    style={{ width: `${width}%` }}
                  />
                ))}
              </div>
            ))}
          </div>
        ) : (
          <div className="loading-card">
            {Array.from({ length: variant === 'detail' ? 6 : 5 }, (_, i) => (
              <div className="loading-row" key={i}>
                <span className="loading-block" />
                <span className="loading-block" />
                <span className="loading-block" />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
